import { ISelect } from "@interfaces/Shared/select";
import TCreateEditPartner from "types/Partner/createEditPartner";

const partnerItemMapper = (formValues: any): TCreateEditPartner => ({
  name: formValues.name,
  description: formValues.description,
  imageUrl:
    typeof formValues.imageUrl === "string" ? formValues.imageUrl : undefined,
  heroImageUrl:
    typeof formValues.heroImageUrl === "string"
      ? formValues.heroImageUrl
      : undefined,
  order: Number(formValues.order),
  removeImageUrl: formValues.removeImageUrl,
  removeHeroImageUrl: formValues.removeHeroImageUrl,
  artists: formValues.artists.map((artist: ISelect) => artist.value),
});

export default partnerItemMapper;
